import me from "models/me";
import { DRIVE_LINK } from "containers/folders/utils/constants";
import type { IRouter } from "./url/page";

export default function redirectOnLogin(router: IRouter) {
    if (!me.isSignedIn()) {
        return;
    }

    const { redirect, mobile } = router.location.query;
    if (mobile) {
        return;
    } else if (redirect) {
        if (redirect.includes("://")) {
            window.location.href = redirect;
        } else {
            router.replace({ pathname: redirect });
        }
    } else if (me.hasCollectionsAccess()) {
        router.replace({ pathname: DRIVE_LINK });
    } else {
        router.replace({ pathname: me.account_type === "buyer" && !me.last_brand ? "/dashboard" : "/brands" });
    }
}
